<div class="layout-col full">
  <!-- Toolbar -->
  <mat-toolbar elderTheme color="primary" class="layout-row place-start-center gap-sm">
    <button mat-icon-button matDialogClose>
      <mat-icon>close</mat-icon>
    </button>
    <elder-header
      [header]="('storageGroups.storageGroup' | translate) + ' ' + data?.storageGroup?.id"
      [subheader]="(storageScope$ | async)?.serialize()"
    >
    </elder-header>
  </mat-toolbar>

  <!-- Content -->
  <elder-basic-pane-layout class="flex bg-background">
    <elder-pane>
      @if (storageGroup$ | async; as storageGroup) {
        <app-storage-manager-packages
          class="flex"
          [storageGroup]="storageGroup"
          [storageScope]="data?.storageScope"
          (movePackages)="onMove($event)"
          (packageSelected)="updateSelectedPackage($event)"
        >
        </app-storage-manager-packages>
      }
    </elder-pane>
    <elder-pane>
      @if (pkg$ | async; as pkg) {
        <div class="flex">
          <elder-pane-header>
            <elder-pane-title>{{ 'packages.package' | translate }}</elder-pane-title>
            <elder-pane-subtitle>{{ pkg.id }}</elder-pane-subtitle>
            <elder-pane-actions></elder-pane-actions>
          </elder-pane-header>
          <elder-pane-content>
            <app-storage-manager-package-detail [package]="pkg">
            </app-storage-manager-package-detail>
          </elder-pane-content>
        </div>
      }
    </elder-pane>
  </elder-basic-pane-layout>
</div>
